import type { ReactNode, SVGProps } from 'react'

/** Bij de sectie-uitleg, permanent zichtbaar en nooit achter een tooltip (R-10, d3, R-157). */
export function InfoIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 'var(--nwo-space-sp-4)', height: 'var(--nwo-space-sp-4)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="11" x2="12" y2="16" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  )
}
